import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { getConsent, setConsent } from "@/lib/consent";

export function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!getConsent()) setShow(true);
  }, []);

  const decide = (accept: boolean) => {
    setConsent({ analytics: accept, marketing: accept });
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed inset-x-3 bottom-3 z-50 sm:inset-x-auto sm:bottom-4 sm:right-4 sm:max-w-md">
      <div className="rounded-2xl border border-border bg-card p-4 shadow-elevated">
        <div className="flex items-start gap-3">
          <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-accent text-accent-foreground">
            <Cookie className="h-4 w-4" />
          </span>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold">We use cookies</p>
            <p className="mt-1 text-xs text-muted-foreground">
              Essential cookies keep Peopels working. With your consent we also use analytics to improve the platform. Manage anytime under <a href="/privacy" className="underline">Privacy settings</a>.
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              <Button size="sm" onClick={() => decide(true)}>Accept all</Button>
              <Button size="sm" variant="outline" onClick={() => decide(false)}>Essential only</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
